import React from 'react'
import { LABEL } from '../../veriables';
import Modal from '@components/common/Modal';
import cn from 'classnames';
import style from './loyaltyCopy.module.scss';
import PropTypes from "prop-types";


const LoyaltyWelcomeSignedInScreen = (props) => {
    const { deleteLoyalty, loyaltyInfo, handleLoyaltyNotNow, storeImage, serverAppTheme, isDeleteLoyalty, setIsDeleteLoyalty } = props
    return (
        <>
            <div className={cn('col-12 p-0 h-100 row mx-0 text-center ')}>
                <div className='col-12 px-0 h-20 pt-2 pb-1'>
                    {(loyaltyInfo?.signUpImageUrl || loyaltyInfo?.imageUrl) ? <img src={loyaltyInfo.signUpImageUrl || loyaltyInfo.imageUrl} alt="loyaltyInfoImage" className='w-100 h-100' /> : storeImage.imageUrl !== '' ? <img src={storeImage.imageUrl} alt='storeImage' className='w-100 h-100' /> : <div className='w-100'>img</div>}
                </div>
                <div className="w-100 row mx-0 h-80 justify-content-center">
                    <div className='col-12 px-0 h-80 fs_32 fw-400 d-flex justify-content-center align-items-center' style={{ color: serverAppTheme?.primary_text }}>
                        Welcome back
                    </div>
                    <div className="col-12 px-0 py-2 px-0 w-100 h-15 d-flex align-items-end">
                        <button type="button" className={cn('btn-ripple btn70 fw-600 fs_28 w-100', style.loyalty_btn)} onClick={() => handleLoyaltyNotNow(false)}>
                            <div>{LABEL().CONTINUE}</div>
                        </button>
                    </div>
                    <div
                        className="col-12 px-0 h-5 text-center fs_28 fw-600"
                        role='button'
                        tabIndex="0"
                        onClick={() => setIsDeleteLoyalty(true)}
                    >
                        <h5>
                            <b style={{ textDecoration: 'underline', color: serverAppTheme?.NO_RECEIPT }}>
                                {LABEL().LS_CHANGE_ACCOUNT}
                            </b>
                        </h5>
                    </div>
                </div>
            </div>
            {isDeleteLoyalty && (
                <Modal
                    isOpen={isDeleteLoyalty}
                    isModalCenter
                >
                    <div className='col-12 p-2 row mx-0 fs-18 fw-600 text-center'>
                        <div className='p-1'>{CUSTOM_MESSAGES().DELETE_LOYALTY_ACCOUNT}</div>
                        <div className='col-6 p-1'>
                            <button type='button' onClick={() => setIsDeleteLoyalty(false)} className='btn w-100 rounded od-btn-primary btn-primary btn-ripple'>{LABEL().NO}</button>
                        </div>
                        <div className='col-6 p-1'>
                            <button type='submit' onClick={() => { setIsDeleteLoyalty(false); deleteLoyalty(); }} className='btn w-100 rounded od-btn-primary btn-primary btn-ripple'>{LABEL().YES}</button>
                        </div>
                    </div>
                </Modal>
            )}
        </>
    );
}

LoyaltyWelcomeSignedInScreen.propTypes = {
    deleteLoyalty: PropTypes.func,
    loyaltyInfo: PropTypes.shape({
        signUpImageUrl: PropTypes.string,
        imageUrl: PropTypes.string,
    }),
    handleLoyaltyNotNow: PropTypes.func,
    storeImage: PropTypes.shape({
        imageUrl: PropTypes.string,
    }),
    serverAppTheme: PropTypes.shape({
        primary_text: PropTypes.string,
        NO_RECEIPT: PropTypes.string,
    }),
    isDeleteLoyalty: PropTypes.bool,
    setIsDeleteLoyalty: PropTypes.func,
};

LoyaltyWelcomeSignedInScreen.defaultProps = {
    deleteLoyalty: () => { },
    loyaltyInfo: {
        signUpImageUrl: "",
        imageUrl: "",
    },
    handleLoyaltyNotNow: () => { },
    storeImage: {
        imageUrl: "",
    },
    serverAppTheme: {
        primary_text: "",
        NO_RECEIPT: "",
    },
    isDeleteLoyalty: false,
    setIsDeleteLoyalty: () => { },
};

export default React.memo(LoyaltyWelcomeSignedInScreen);
